module.exports = __webpack_public_path__ + "cbe732775ee0c8444d1b46aa1d89686f.png";